'use client';

export default function OpenSidemenu() {  
    if (typeof window !== "undefined") {
        localStorage.setItem("ismenuOpen",'false');
    }

    const handleClick = () => {
        if (typeof window !== "undefined") {
            localStorage.setItem("ismenuOpen",'true');
            window.dispatchEvent(new Event("sidemenuToggle"));
        }
      };
    
    return(        
        <button aria-label="Sidebar Menu" type="button" className="d-none d-lg-inline-block side_menu_btn" onClick={handleClick}></button>                    
    )  
};

